import React from "react";
import "../css/Gallery.css";

const Gallery = () => {
  const images = [
    "https://images.pexels.com/photos/841130/pexels-photo-841130.jpeg",
    "https://images.pexels.com/photos/1954524/pexels-photo-1954524.jpeg",
    "https://images.pexels.com/photos/1552249/pexels-photo-1552249.jpeg",
    "https://images.pexels.com/photos/3823039/pexels-photo-3823039.jpeg",
    "https://images.pexels.com/photos/6453399/pexels-photo-6453399.jpeg",
    "https://images.pexels.com/photos/140955/pexels-photo-140955.jpeg",
    "https://images.pexels.com/photos/414029/pexels-photo-414029.jpeg",
    "https://images.pexels.com/photos/1552252/pexels-photo-1552252.jpeg",
    "https://images.pexels.com/photos/1552242/pexels-photo-1552242.jpeg"
  ];

  return (
    <div className="gallery4">

      {/* HERO SECTION */}
      <section className="gal-hero">
        <h1>Playground Gallery</h1>
        <p>Fun moments. Bright energy. Real Shank vibes.</p>
      </section>


      {/* MIXED SHAPES MOSAIC */}
      <section className="gal-mosaic">
        <div className="gal-grid">

          {/* First row */}
          <div className="gal-item tall">
            <img src={images[0]} alt="" />
          </div>

          <div className="gal-item round">
            <img src={images[1]} alt="" />
          </div>

          <div className="gal-item blob">
            <img src={images[2]} alt="" />
          </div>

          {/* Second row */}
          <div className="gal-item blob big">
            <img src={images[3]} alt="" />
          </div>

          <div className="gal-item">
            <img src={images[4]} alt="" />
          </div>

          <div className="gal-item round">
            <img src={images[5]} alt="" />
          </div>

          {/* Third row */}
          <div className="gal-item wide">
            <img src={images[6]} alt="" />
          </div>

          <div className="gal-item blob">
            <img src={images[7]} alt="" />
          </div>

          <div className="gal-item">
            <img src={images[8]} alt="" />
          </div>

        </div>
      </section>

    </div>
  );
};

export default Gallery;
